import styled from 'styled-components';

const Container = styled.label`
  display: block;
  position: relative;
  padding-left: 25px;
  cursor: pointer;
  font-size: 14px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  color: ${(props) => (props.textColor ? props.textColor : '#000')};
  line-height: initial;
  width: ${(props) => (props.width ? props.width : undefined)};
  margin: ${(props) => (props.margin ? props.margin : '0')};
  @media (hover: hover) {
    &:hover {
      input ~ .checkMark {
        background-color: ${({ theme }) => theme.COLOR_BLACK};
        &:after {
          opacity: 0.8;
        }
      }
    }
  }
`;

const CheckBox = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
  &:checked ~ .checkMark {
    background-color: ${(props) =>
      props.color
        ? props.color
        : ({ theme }) => theme.COLOR_PRIMARY_BUTTON} !important;
    &:after {
      opacity: 1 !important;
    }
  }
`;

const CheckMark = styled.span`
  position: absolute;
  top: 1.5px;
  left: 0;
  height: 18px;
  width: 18px;
  border-radius: 4px;
  transition: background-color 0.1s ease-in-out;
  border: 1px solid ${({ theme }) => theme.COLOR_PRIMARY_BUTTON};
  &:after {
    left: 4px;
    top: 0px;
    width: 6px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    content: '';
    opacity: 0;
    position: absolute;
    transition: opacity 0.1s ease-in-out;
  }
`;

const StyledTableCheckbox = {
  Container,
  CheckBox,
  CheckMark,
};

export default StyledTableCheckbox;
